import { render } from "./AiPlayer.vue?vue&type=template&id=aa23ddb2"
import script from "./AiPlayer.vue?vue&type=script&lang=js"
export * from "./AiPlayer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__